<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card>
      <v-card-title class="primary white--text title">TAP Alert</v-card-title>
      <v-card-text v-html="dialogText"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" round @click.native="$emit('onOk')">Ok</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    dialogText: '',
    dialog: ''
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AlertDialog.vue